import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import confirm from './modules/confirm';
import listener from './modules/listener';
import preferences from './modules/preferences';
import registration from './modules/registration';
import request from './modules/request';
import invoice from './modules/invoice';
import user from './modules/user';
import toasts from './modules/toasts';

const store = new Vuex.Store({
	modules: {
		confirm,
		listener,
		registration,
		preferences,
		user,
		toasts,
		request,
		invoice,
	}
});

export default store;
